import { render, staticRenderFns } from "./MMP_TabNav.vue?vue&type=template&id=0c8bd5b3&scoped=true&"
import script from "./MMP_TabNav.vue?vue&type=script&lang=js&"
export * from "./MMP_TabNav.vue?vue&type=script&lang=js&"
import style0 from "./MMP_TabNav.vue?vue&type=style&index=0&id=0c8bd5b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8bd5b3",
  null
  
)

export default component.exports